<template>
  <div>
    <el-form ref="formRef" :model="smsForm" label-width="88px">
      <el-form-item label="城市：">
        <el-select v-model="province" placeholder="Select" style="width: 11.5em;margin-right: 1em" @change="changeCity" >
          <el-option v-for="item in provinceList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
        <el-select v-model="city" placeholder="Select" style="width: 11.5em">
          <el-option v-for="item in cityList" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="URL：">
        <el-input type="text" v-model="smsForm.url" placeholder="请输入URL" style="width:24em;"/>
      </el-form-item>
      <el-form-item label="客服昵称：">
        <el-input type="text" v-model="smsForm.nickname" placeholder="请输入客服昵称" style="width:24em;"/>
      </el-form-item>
      <el-form-item label="客服微信：">
        <el-input type="text" v-model="smsForm.wechatId" placeholder="请输入客服微信" style="width:24em;"/>
      </el-form-item>
      <el-form-item label="短信ID：">
        <el-input type="text" v-model="smsForm.smsCode" placeholder="请输入短信ID" style="width:24em;"/>
      </el-form-item>
      <el-form-item label="短信来源">
        <el-select v-model="smsSource" placeholder="Select" style="width: 11.5em;margin-right: 1em" @change="changeCity" >
          <el-option v-for="item in smsSourceArray" :key="item.value" :label="item.label" :value="item.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="客服头像：">
        <img :src="src" alt="" v-if="src" @click="headImgUpdate" class="cursor" style="width: 80px;height: 80px;margin: 0">
        <div class="add" @click="headImgUpdate" v-else>
          <span>+</span>
        </div>
        <input type="file" accept=".jp2,.jpe,.jpeg,.jpg,.png"  @change="headImgChanged" ref="headImg" multiple="multiple" style="display:none;">
      </el-form-item>
    </el-form>
    <div class="dialog-footer" style="text-align: center">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="summit" v-loading="loading">确定</el-button>
    </div>
  </div>

</template>

<script>
import { imgPostFormData, getFormData } from "@/api/api"
import { addOrUpdateMatchmakerSms,areaList } from "@/api/url";
import { urlReg } from "../../../assets/shared/reg-constant";

export default {
  name: "TagManageDialog",
  props: {
    value: Object
  },
  data() {
    return {
      smsForm: this.value.smsForm,
      idx: this.value.ids,
      loading: false,

      province: this.value.smsForm.province?this.value.smsForm.province:'-1',
      city: this.value.smsForm.city?this.value.smsForm.city:'-1',
      provinceList: [
        {label: '不限', value: '-1'}
      ],
      cityList: [],

      smsSourceArray: [
        {label: "赛邮短信", value: 1},
        // {label: "示远短信", value: 2}
      ],
      smsSource: 1,

      files: null,
      src: this.value.ids > -1?this.value.smsForm.avatar:'',

    }
  },
  methods: {
    cancel() {
      this.$emit("close");
    },

    //更改或添加
    headImgUpdate() {
      this.$refs.headImg.click();
    },

    //选取图片
    headImgChanged(e) {
      if(e.target.files[0]) {
        this.files = e.target.files[0];
        var windowURL = window.URL || window.webkitURL;
        this.src = windowURL.createObjectURL(this.files);
      }
    },

    summit() {
      if(!this.smsForm.url) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: 'url不能为空',
          type: 'warning'
        });
        return false
      }
      if(this.smsForm.url && !urlReg.test(this.smsForm.url)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: "url不正确",
          type: 'warning'
        });
        return;
      }
      if(!this.smsForm.nickname) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '客服昵称不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.smsForm.wechatId) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '客服微信不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.smsForm.smsCode) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '短信ID',
          type: 'warning'
        });
        return false
      }
      if(!this.src) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '客服头像不能为空',
          type: 'warning'
        });
        return false
      }
      this.loading = true
      let _this = this
      let param = new FormData();
      if (this.idx > -1) {
        param.append('id', this.smsForm.id);
      } else {
        param.append('id', '0');
      }
      param.append('nickname', this.smsForm.nickname);
      param.append('wechatId', this.smsForm.wechatId);
      param.append('province', this.province);
      param.append('city', this.city);
      param.append('smsSource', this.smsSource);
      param.append('smsCode', this.smsForm.smsCode);
      param.append('url', this.smsForm.url);
      param.append('state', this.smsForm.state?this.smsForm.state:0);
      param.append('file', this.files);
      imgPostFormData(addOrUpdateMatchmakerSms, param).then((data) => {
        let {msg, code} = data
        if (code == 200) {
          _this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'success'
          });
          _this.$emit('confirm')
        }else {
          this.$message({
            showClose: true,
            duration: 2000,
            message: msg,
            type: 'warning'
          });
        }
        _this.loading = false
      }).catch(()=>{
        _this.loading = false
      })
    },

    changeCity() {
      this.cityList = []
      if(this.province == -1) {
        this.cityList.push({label:'不限', value: '-1'})
      }else {
        for(let i=0; i<this.provinceList.length; i++) {
          if (this.province == this.provinceList[i].province) {
            let citys = this.provinceList[i].cityList
            citys.forEach(item => {
              let obj = {}
              obj.label = item.city
              obj.value = item.city
              this.cityList.push(obj)
            })
          }
        }
      }
      this.city = this.cityList[0].value
    },

    getAreaList() {
      getFormData(areaList).then((data)=>{
        let {msg, code} = data
        if (code == 200) {
          let dataList = data.data
          dataList.forEach(item => {
            item.label = item.province
            item.value = item.province
          })
          this.provinceList = this.provinceList.concat(dataList);
          if(this.province == -1) {
            this.cityList.push({label:'不限', value: '-1'})
          }else {
            for(let i=0; i<this.provinceList.length; i++) {
              if (this.province == this.provinceList[i].province) {
                let citys = this.provinceList[i].cityList
                citys.forEach(item => {
                  let obj = {}
                  obj.label = item.city
                  obj.value = item.city
                  this.cityList.push(obj)
                })
              }
            }
          }
        }else {
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
      })
    },

  },
  mounted() {
    this.getAreaList()
  }
}
</script>

<style scoped>
.add {
  width: 80px;
  height: 80px;
  text-align: center;
  line-height: 80px;
  border: 1px dashed #ececec;
  font-size: 30px;
  cursor: pointer;
  float: left;
}
</style>
